import React from "react";
import a23logo from '../assets/a23_avatar_logo.png'
import close from '../assets/close.png'
import pl_edit_iv from '../assets/pl_edit_iv.png'
import { connect } from "react-redux";
import { toggleModalAction, getUPIInfo,toggleAlertAction } from '../redux/actions/userAction'
import VerificationAlert from "../models/UpiAlert";
import { Spinner } from 'react-awesome-spinners'
import { VERIFYUPI_STRINGS, REDEEMPAGE_STRINGS } from '../Strings'
class VerifyUPI extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      upi_number: "",
      reenter_upi_number: "",
      errors: {
        message: "",
      },
      upiaccountname: "",
      upistatus: "",
      btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}`,
      isAllfieldsEnter: true,
      duplicatedata: "",
      deleteddata: "",
      isBackSpaceTriggered: false,
      dummy: "1",
      editViewClicked: false,
      isshowloading: false,
      toShowEditIcon: false,
      channel: window.sessionStorage["channel"],
      userClickedOnBackSpace: false,
      disableButtonClick: false,
      upiState:"",
      confirmAccountName:""
    };
  }

  // onKeyUp=evt=>{
  //   console.log("input event keydowncode:"+evt.keyCode+"..."+evt.key+"..."+evt.charCode)
  //   this.handleBackSpace("onkeyup",evt)
  // }
  //  handleBackSpace(from,evt){
  //     if(from === "onchange"){
  //       this.setState({deleteddata:evt.target.value,})
  //     }
  //     console.log("from in handleBackSpace::"+from+"...event"+evt+"..."+evt.target.value+"...deleteddata"+this.state.deleteddata+"..."+this.state.upi_number.length+"..."+this.state.duplicatedata.length)
  //     if(from === "onkeyup"){

  //       let userAgent = window.navigator.userAgent.toLocaleLowerCase();
  //       console.log("useragent string::",userAgent.toString())
  //       if (userAgent.toString().includes("wv")){
  //         console.log("backspace if::")
  //         if(evt.key === "Backspace"){
  //         if(evt.keyCode === 229 || evt.keyCode === 8){
  //           if(this.state.upi_number.length !== this.state.duplicatedata.length-1){
  //             if(this.state.duplicatedata.length === 1){
  //               this.setState({dummy:"1"})
  //             }
  //             var x=this.state.duplicatedata.substring(0,this.state.upi_number.length-1)
  //             console.log("value of x in handlebackspace:"+x)
  //             this.setState({duplicatedata:x,upi_number : this.state.deleteddata})
  //          }

  //         }
  //       }
  //       }else{
  //         console.log("backspace else::")
  //         if(evt.keyCode === 8 || evt.key === "Backspace"){
  //           if(this.state.upi_number.length !== this.state.duplicatedata.length-1){
  //             if(this.state.duplicatedata.length === 1){
  //               this.setState({dummy:"1"})
  //             }
  //             var x=this.state.duplicatedata.substring(0,this.state.upi_number.length-1)
  //             console.log("value of x in handlebackspace:"+x)
  //             this.setState({duplicatedata:x,upi_number : this.state.deleteddata})
  //          }

  //         }
  //       }

  //     }
  //   }

  async componentDidMount() {
    this.inputRef = React.createRef()
  }
  onChange = (e) => {

    console.log("event name in onchange:", e.target.name + "...target value length" + e.target.value.length + "...dumy value length" + this.state.dummy.length + "...editviewclicked" + this.state.editViewClicked + "...userClickedOnBackSpace" + this.state.userClickedOnBackSpace)
    if (!this.state.userClickedOnBackSpace) {
      //if(e.target.name === "reenter_upi_number"){
        e.target.value=e.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,'')
      //}
      this.setState({ [e.target.name]: e.target.value, isAllfieldsEnter: true,disableButtonClick:false});
      if (this.state.editViewClicked) {
        this.setState({ loading: false, btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}`, editViewClicked: false, toShowEditIcon: false, isAllfieldsEnter: true,disableButtonClick:false })
      }
      // if (e.target.name === "upi_number") {
      //   if (e.target.value.length >= this.state.dummy.length) {
      //     for (var i = 0; i < e.target.value.length; i++) {
      //       var str = e.target.value.substring(e.target.value.length - 1, e.target.value.length)
      //       var x = this.state.duplicatedata + str
      //       console.log("value in loop", str + "...duplicatedata", this.state.duplicatedata + "...x" + x)
      //       this.setState({ duplicatedata: x })

      //     }
      //     var dummyText = Array(e.target.value.length).fill('*').join("");
      //     console.log("text:::", dummyText)
      //     this.setState({ [e.target.name]: dummyText,dummy:dummyText });
      //   }
      //   else {
      //     this.handleBackSpace("onchange",e)
      //   }
      // } else {
      //   this.setState({ [e.target.name]: e.target.value });
      // }
    } else {
      this.setState({ upi_number: "", reenter_upi_number: "", loading: false, btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}`, userClickedOnBackSpace: false, editViewClicked: false, dummy: "1", duplicatedata: "", toShowEditIcon: false, isAllfieldsEnter: true,disableButtonClick:false });
    }
  }

  handleCloseButton = () => {
    console.log("wallet type in closebtn click::", this.props.walletType)
    this.props.toggleModalAction(false)
    if (this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`) {
      this.props.updateRedeemDetails(this.props.walletType)
    }
  }

  handleUPIStatus = () => {
    console.log("upi status in handleUPIStatus", this.state.upistatus, this.state.disableButtonClick,this.state.upiState)
    if (this.state.upiState === `${VERIFYUPI_STRINGS.KEY_REJECTED_TV}`) {
    } else {
      if (this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`) {
        this.props.updateRedeemDetails(this.props.walletType)
      }
      this.props.toggleModalAction(false)
      this.props.toggleModalAction(
        true,
        <VerificationAlert
          header={VERIFYUPI_STRINGS.KEY_VERIFY_UPI_SUCCESS_HEADER_TV}
          body={VERIFYUPI_STRINGS.KEY_VERIFY_UPI_SUCCESS_MSG_TV}
          btntext={VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}
        ></VerificationAlert>
      );
    }
  }
  verifyBtnClick = async () => {


    console.log("upi number in onsubmit:::", this.state.upi_number + "....reenter upi number", this.state.reenter_upi_number + "...button text" + this.state.btntxt + "...duplicate data" + this.state.duplicatedata)
    if (this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`) {
      console.log("if")
      if (this.state.disableButtonClick) {
        console.log("if disable")
        return;
      }
      this.setState({ disableButtonClick: true })
      await this.props.getUPIInfo(this.state.upi_number.toLocaleLowerCase(), this.state.reenter_upi_number.toLowerCase(), "", window.sessionStorage["upitoken"], true, this.state.channel)
      this.handleUPIStatus()
    } else {
      console.log("else")
      if (this.state.upi_number === "") {
        this.setState({ errors: { message: `${VERIFYUPI_STRINGS.KEY_UPI_EMPTY_MSG_TV}` } });
        return false;
      } else if (this.state.reenter_upi_number === "") {
        this.setState({ errors: { message: `${VERIFYUPI_STRINGS.KEY_REENTER_UPI_EMPTY_MSG_TV}` } });
        return false;
      } else if (!(this.state.upi_number.toLowerCase() === this.state.reenter_upi_number.toLowerCase()) && (this.state.upi_number != null && this.state.reenter_upi_number != null)) {
        this.setState({ errors: { message: `${VERIFYUPI_STRINGS.KEY_UPI_MISMATCH_TV}` }, isAllfieldsEnter: false });
        return false;
      } else {
        this.setState({ btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFYING_BTN_TV}`, isAllfieldsEnter: false, isshowloading: true, errors: { message: "" } });

        await this.props.getUPIInfo(this.state.upi_number.toLowerCase(), this.state.reenter_upi_number.toLowerCase(), "", window.sessionStorage["upitoken"], false, this.state.channel)


        const { upidata } = this.props.modalState;
        console.log("upi data in verifyupi class::::", upidata);
        if (upidata.error) {
          console.log("upi data error if::::", upidata.error);
          await this.setState({
            errors: { message: upidata.error.message },
            //isAllfieldsEnter: true,
            btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}`,
            isshowloading: false,
            toShowEditIcon: false,
            isAllfieldsEnter: false
          });
        } else {
          console.log("upi data else");
          await this.setState({
            //bankStatus: bankDetails.bankStatus,
            //isbankStatus: true,
            //isShowTimer: false
            errors: { message: "" },
            loading: true,
            upiaccountname: upidata.nameAtBank,
            upistatus: upidata.vpa,
            isAllfieldsEnter: true,
            upiState:upidata.upiState,
            btntxt: `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`,
            isshowloading: false,
            toShowEditIcon: true,
            confirmAccountName:upidata.message
          });

          if(upidata.upiState == VERIFYUPI_STRINGS.KEY_REJECTED_TV){
            this.setState({disableButtonClick:true,isAllfieldsEnter:false})
          }
        }
      }
    }
  }

  handleEditViewClick = () => {
    console.log("handleEditViewClick method called:", this.state.btntxt)
    if (this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`) {
      this.setState({ editViewClicked: true })
      setTimeout(() => {
        this.inputRef.current.focus();
      }, 200);

    }
  }

  onKeyDown = (evt) => {
    console.log("onKeyDown value in verify upi::", evt.keyCode + "....", evt.key + "...button text", this.state.btntxt)
    if (evt.keyCode === 8 || evt.key === "Backspace") {
      if (this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}`) {
        this.setState({ userClickedOnBackSpace: true })
      }
    }
    if (evt.keyCode === 13) {
      evt.target.blur();
    }
  }
  render() {
    console.log("btn text in onrender:", this.state.btntxt)
    return (
      <div >
        <div class="relative absolute--fill flex justify-center items-center center left-1 right-1 white w7 ">
          <img class="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  pointer z-9999 " src={a23logo} alt="no"></img>
          <div className="center br2 ba pa1 b--black-10 flex flex-column" style={{ backgroundColor: "#fffdea", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem" }}
          >
            <div className="w-100 db ph2 pt2 f6 mt3">
              <img class="absolute top-0 right-0 pa2 w2" src={close} alt="no" onClick={() => this.handleCloseButton()}></img>
              <h4 className=" mt0  fw6 tc">{VERIFYUPI_STRINGS.KEY_UPI_HEADER_TV}</h4>
              <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">
                <div className="f6 center w-100 flex flex-column items-center pa1">
                  <div className="flex w-100 justify-between items-center pa1 bb b--gray">
                    <input
                      type="password"
                      id="upi-id"
                      name="upi_number"
                      ref={this.inputRef}
                      disabled={((this.state.btntxt === "Okay" || this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_VERIFYING_BTN_TV}`) && !this.state.editViewClicked) ? true : false}
                      placeholder={VERIFYUPI_STRINGS.KEY_ENTER_UPI_HINT_TV}
                      className="w-90 h2  bl-0 bt-0 br-0 bb-0 bg-transparent outline-0"
                      value={this.state.upi_number}
                      onKeyDown={(e) => this.onKeyDown(e)}
                      onChange={e => this.onChange(e)}
                      autoComplete="off"
                    >
                    </input>
                    {this.state.toShowEditIcon && (
                      <img src={pl_edit_iv} alt="" onClick={() => this.handleEditViewClick()} className="w1" />)}
                  </div>
                  <div className="w-100 mt1 pa1 bb b--gray">
                    <input
                      type="text"
                      id="re-upi-id"
                      name="reenter_upi_number"
                      disabled={((this.state.btntxt === "Okay" || this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_VERIFYING_BTN_TV}`) && !this.state.editViewClicked) ? true : false}
                      placeholder={VERIFYUPI_STRINGS.KEY_RE_ENTER_UPI_HINT_TV}
                      className="w-100 h2  bl-0 bt-0 br-0 bb-0 bg-transparent outline-0"
                      style={(this.state.reenter_upi_number.length == 0 ? undefined : {textTransform:"lowercase"})}
                      onKeyDown={(e) => this.onKeyDown(e)}
                      value={this.state.reenter_upi_number}
                      onChange={e => this.onChange(e)}
                      autoComplete="off"
                    ></input>
                  </div>
                  <div className="w-100 ">
                    <div className="f6 mt1 tl f6 f4-l f5-ns red" id="error-msg">
                      {this.state.errors.message}
                    </div>
                  </div>
                </div>
              </form>
              {this.state.isshowloading && (
                <div className="center tc mr5 ">
                  <div className="center tc mr5"><Spinner size={64} color='#eabf69' sizeUnit='px'  ></Spinner></div>
                </div>
              )}
              {this.state.loading && (
                <div className="tc f6 h2 mv3 pl1 flex flex-column">
                  <div className="b f6 tl " style={{ color: "#032146" }}>
                    {REDEEMPAGE_STRINGS.KEY_ENTER_ACCOUNT_NAME} :<span className="b f6"> {this.state.upiaccountname} </span>{" "}
                  </div>
                  <div>
                    <p className="b f6 tl" style={{ color: "#8B99AB" }}>
                      {this.state.confirmAccountName}
                    </p>
                  </div>
                </div>
              )}

              <div className="w-100 mt5 tc f6 flex flex-column ">
              {window.sessionStorage["channel"] == "GAPS" || window.sessionStorage["channel"] == "GFPS" ?( <div className="f7 f6-l fw6 tl mt1" style={{ color: "#032146" }}>
                 {VERIFYUPI_STRINGS.KEY_VERIFY_UPI_NOTE_TV_PLAYSTORE}
                </div>):( <div className="f7 f6-l fw6 tl mt1" style={{ color: "#032146" }}>
                 {VERIFYUPI_STRINGS.KEY_VERIFY_UPI_NOTE_TV}
                </div>)}
                {this.state.isAllfieldsEnter ? (
                  <div>
                    {this.state.upi_number.length > 0 && this.state.reenter_upi_number.length > 0 ? (
                      <button className="w-40 center mt3  pv2  ph4 br3 white fw5 btn-green btn-green-login" disabled={this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_OKAY_BTN_TV}` ? this.state.disableButtonClick : false} onClick={() => this.verifyBtnClick()}>
                        {this.state.btntxt}
                      </button>) :
                      (
                        <button
                          className="w-40 center mt3 pa2 br3 bw0 white fw5"
                          style={{ backgroundColor: "#7F8485" }} disabled={true}>
                          {this.state.btntxt}
                        </button>
                      )}

                  </div>

                ) : (
                    <div>
                      {this.state.btntxt === `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}` ? (
                        <button
                          className="w-40 center mt3 pa2 br3 bw0 white fw5"
                          style={{ backgroundColor: "#7F8485" }} disabled={true}>
                          {this.state.btntxt}
                        </button>
                      ) : (
                          <button
                            className="w-40 mt2 f6 f4-l f5-ns ph3 pv2 br3 mt3 bw0 tc fw6 center"
                            style={{ borderColor: "#959595", color: "#959595" }}>
                            {this.state.btntxt}
                          </button>
                        )}
                    </div>

                  )}
                <div className="h1"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  modalState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction, toggleAlertAction,getUPIInfo }
)(VerifyUPI);